import React from "react";
import "./index.css";
import Myself from "./Myself";

const ShaderComp = () => {
  return <Myself />;
};

export default ShaderComp;
